import React, { useEffect } from 'react'

const Hidden = (props) => {
    const { value, name, setValue, ...rest } = props

    useEffect(()=>{
        if (name) {
            setValue(name, value ?? "")
        }
    },[name, setValue, value])
    return (
        <></>
    )
}

export default Hidden
